export default ref => window.scrollTo(0, ref.current.offsetTop)